import type { ReactNode } from 'react';
import { TenantProvider } from '@/stores/TenantStore';
import { SessionProvider } from '@/stores/SessionStore';
import { PermissionProvider } from '@/stores/PermissionStore';
import { BranchProvider } from '@/stores/BranchStore';

/**
 * Composition root for the auth concern. Nests the dedicated stores in dependency order:
 *   TenantStore (tenant code) → SessionStore (profile/login/logout) → PermissionStore (derived)
 *   → BranchStore (company + accessible/current branch, loaded once authenticated).
 * Kept as `AuthProvider` so the single wrapper in main.tsx is unchanged; consumers use `useAuth`
 * (session/permission/tenant) and `useBranchContext` (branch).
 */
export function AuthProvider({ children }: { children: ReactNode }) {
  return (
    <TenantProvider>
      <SessionProvider>
        <PermissionProvider>
          <BranchProvider>{children}</BranchProvider>
        </PermissionProvider>
      </SessionProvider>
    </TenantProvider>
  );
}
